import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiState, BaseApiResponse } from '../../models/generics';
import { TCart } from '../../services/cart/models/cart';

export interface TCartState {
  getCartApiState: ApiState;
  cart?: TCart;
  getCartError?: BaseApiResponse<null>;
  displayErrorMessage?: string;
}

// Initial state
const initialState: TCartState = {
  getCartApiState: ApiState.IDLE,
  cart: undefined,
  getCartError: undefined,
  displayErrorMessage: undefined,
};

// Create the slice
const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    cartLoading: (state) => {
      state.getCartApiState = ApiState.LOADING;
    },
    
    cartSuccess: (state, action: PayloadAction<TCart>) => {
      state.getCartApiState = ApiState.SUCCESS;
      state.cart = action.payload;
      state.getCartError = undefined;
      state.displayErrorMessage = undefined;
    },
    
    cartError: (state, action: PayloadAction<{ error: any, displayErrorMessage: string }>) => {
      state.getCartApiState = ApiState.FAILED;
      state.getCartError = action.payload.error;
      state.displayErrorMessage = action.payload.displayErrorMessage;
    },
    
    updateCart: (state, action: PayloadAction<TCart>) => {
      state.cart = action.payload;
    },
   
    addItemToCartSuccess: (state, action: PayloadAction<TCart>) => {
      state.cart = action.payload;
    },
    
    removeCouponSuccess: (state, action: PayloadAction<TCart>) => {
      state.cart = action.payload;
    },
    
    applyCouponSuccess: (state, action: PayloadAction<TCart>) => {
      state.cart = action.payload;
    },
    
    updateCartItemQuantitySuccess: (state, action: PayloadAction<TCart>) => {
      state.cart = action.payload;
    },
    
    removeItemFromCartSuccess: (state, action: PayloadAction<TCart>) => {
      state.cart = action.payload;
    },
    
    updateCartItemTenureSuccess: (state, action: PayloadAction<TCart>) => {
      state.cart = action.payload;
    },
    
    applyVasSuccess: (state, action: PayloadAction<TCart>) => {
      state.cart = action.payload;
    }
  }
});

// Export actions and reducer
export const { 
  cartLoading,
  cartSuccess,
  cartError,
  updateCart,
  addItemToCartSuccess,
  removeCouponSuccess,
  applyCouponSuccess,
  updateCartItemQuantitySuccess,
  removeItemFromCartSuccess,
  updateCartItemTenureSuccess,
  applyVasSuccess
} = cartSlice.actions;

export default cartSlice.reducer;